import { useContext } from 'react';
import { Segment, Sidebar } from 'semantic-ui-react';
import { store } from '../store';
import { TOGGLE_SETTINGS } from '../types';
import Controls from './Controls';

const Settings = () => {
  const { showingSettings, dispatch } = useContext(store);
  const close = () => dispatch({ type: TOGGLE_SETTINGS, payload: false });

  return (
    <Sidebar
      as={Segment}
      animation="scale down"
      visible={showingSettings}
      onHide={close}
      width="very wide"
    >
      <Controls />
    </Sidebar>
  );
};

export default Settings;
